import "./Info3.css";
import Img1 from '../assets/Barumsvägen 417 (11).jpg';
import { useTranslation } from "react-i18next";

const Info3 = () => {
  const { t } = useTranslation();

  return (
    <section id="sell" className="mag-info3-wrapper">
      <div className="mag-info3-container">
        
        <div className="mag-info3-grid">
          <div className="mag-info3-text-col">
            <header className="mag-info3-header">
              <span className="mag-label">{t("info3Label") || "Vår tjänst"}</span>
              <h2 className="mag-info3-title">{t("info3Title")}</h2>
            </header>
            
            <div className="mag-info3-body">
              <p className="mag-lead-text">{t("info3Paragraph1")}</p>
              <div className="mag-info3-divider"></div>
              <p className="mag-secondary-text">{t("info3Paragraph2")}</p>
            </div>
          </div>

          <div className="mag-info3-image-col">
            <div className="mag-img-container">
              <div className="mag-img-frame">
                <img
                  src={Img1}
                  alt={t("info3ImageAlt")}
                  className="mag-info3-img"
                />
              </div>
             
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Info3;